import { useLocation } from 'react-router'
import { isEmbeddedParam } from '../../../../pages/MapPage/query-params'
import joinUrl from '../../../utils/joinUrl'
import { routing } from '../../../../routes'
import { Variant } from '../../Button/Button'
import Icon from '../../Icon/Icon'
import ExternalLink from '../../../assets/icons/externalLink.svg'
import { useIsEmbedded } from '../../../contexts/ui'
import { MapButton } from '../styles'

const EmbedControl = () => {
  const location = useLocation()
  const isEmbedded = useIsEmbedded()

  if (!isEmbedded) {
    return null
  }

  const onClick = () => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete(isEmbeddedParam.name)

    const queryString = searchParams.toString()
    const url = joinUrl([
      'https://data.amsterdam.nl/',
      routing.dataSearchGeo.path,
      `?${queryString}`,
    ])

    window.open(url, '_blank')
  }

  return (
    <MapButton
      data-testid="embedButton"
      variant={Variant.PrimaryInverted}
      aria-label="Naar interactieve kaart"
      onClick={onClick}
    >
      <Icon size={18}>
        <ExternalLink />
      </Icon>
      data.amsterdam.nl
    </MapButton>
  )
}

export default EmbedControl
